export default __webpack_public_path__ + "static/media/fasttypemonwithhand.ece2a127.png";